/* A value Buddy wrote that the trainer has not edited yet (ai-plan-builder R15; AI boards I, S2):
 * underlined, dashed, in the tertiary ink, until the edit makes it the trainer's. Shared by the
 * builder's week and the day panel, which mark the same exercise. */

.aiWritten {
  text-decoration: underline dashed var(--text-3) var(--border-hairline);

  /* 2px under the baseline, where the board draws 4: the week's card names and the day panel's
   * headings are one ellipsised line with `overflow: hidden`, and a 4px offset falls outside their
   * line box and is clipped away. */
  text-underline-offset: var(--space-2px);
}
